
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/Terms",
      function () {
        return require("private-next-pages/support/Terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/Terms"])
      });
    }
  